import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopType from "@/enum/ShopType";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import type GlobalStore from "@/store";
import { Modal } from "antd";
import { ShipValidationResult, ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationSuccessfulResult } from "../util";

/** 如果有部分数量发货/部分数量取消的订单，确认是否继续发货 */
export default async function validateOrderItemPartQuantityOrdersShouldShip(
    orders: OrderDTO[],
    rule: ShipValidationRule,
    globalStore: typeof GlobalStore,
): Promise<ShipValidationResult> {
    if (!rule[ShipValidationRuleKey.checkOrderItemPartQuantityShip]) return buildValidationSuccessfulResult(orders);

    const partQuantityCanceledShopTypeSet = new Set<ShopType>();
    const partQuantityShippedShopTypeSet = new Set<ShopType>();
    /** 提示的序号游标 */
    let index = 1;

    for (const order of orders) {
        if (order.tags) {
            const shopType = globalStore.shopMapping.get(order.shopId)?.type;

            if (order.tags.includes(OrderTag.ORDER_ITEM_PART_QUANTITY_SHIPPED)) {
                partQuantityShippedShopTypeSet.add(shopType);
            }

            if (order.tags.includes(OrderTag.ORDER_ITEM_PART_QUANTITY_CANCELED)) {
                partQuantityCanceledShopTypeSet.add(shopType);
            }
        }
    }

    if (partQuantityCanceledShopTypeSet.size > 0 || partQuantityShippedShopTypeSet.size > 0) {
        const content = [];

        partQuantityCanceledShopTypeSet.forEach((shopType) => {
            const platform = ShopTypeNameMap[shopType];

            content.push(
                `${index++}.有${platform}的订单商品部分数量已取消，将会按照真实待发货商品数量进行发货。建议在${platform}后台查看下订单的部分数量取消情况，核对下面单上的商品数量和拣货数量，避免发错货`,
            );
        });

        partQuantityShippedShopTypeSet.forEach((shopType) => {
            const platform = ShopTypeNameMap[shopType];

            content.push(
                `${index++}.有${platform}的订单商品部分数量已发货，将会按照真实待发货商品数量进行发货。建议在${platform}后台查看下订单的部分数量发货情况，核对下面单上的商品数量和拣货数量，避免发错货`,
            );
        });

        return await new Promise((resolve, reject) => {
            Modal.confirm({
                title: "确认是否继续发货",
                onOk() {
                    resolve(buildValidationSuccessfulResult(orders));
                },
                onCancel() {
                    reject(new Error("用户取消操作"));
                },
                focusable: { focusTriggerAfterClose: true },
                content: (
                    <div className="error">
                        {content.map((item, i) => {
                            return <p key={i}>{item}</p>;
                        })}
                    </div>
                ),
            });
        });
    }

    return buildValidationSuccessfulResult(orders);
}
